/**
 * The words of the HR screens review of 2026-10-07 for the employees, the organisation and the
 * statute screens, medium and low findings (pm human-resources-q7kc1dda, -q7kckmkc, -q7kcr90m,
 * -q7kd1pry, -q7kd5rkd, -q7kdb1sv). Kept beside the catalogue, as the other HR rounds' words are,
 * and spread into it.
 */
export const HR_REVIEW_C_EN = {
    // employees/assignments: one that has not begun, and the primary one told from the extra ones.
    "value.status.upcoming": "Not started yet",
    // org: approved posts beside the people, what is open, a branch's people, the day not yet recorded.
    "unit.candidates.zero": "No candidates",
    "unit.candidates.one": "{n} candidate",
    "unit.candidates.two": "{n} candidates",
    "unit.candidates.few": "{n} candidates",
    "unit.candidates.many": "{n} candidates",
    "unit.candidates.other": "{n} candidates",
};
export const HR_REVIEW_C_AR = {
    "value.status.upcoming": "لم يبدأ بعد",
    "unit.candidates.zero": "لا مرشّحين",
    "unit.candidates.one": "مرشّح واحد",
    "unit.candidates.two": "مرشّحان",
    "unit.candidates.few": "{n} مرشّحين",
    "unit.candidates.many": "{n} مرشّحاً",
    "unit.candidates.other": "{n} مرشّح",
};
//# sourceMappingURL=i18n-hr-review-c.js.map